import React from "react";
import './chip_styles.scss';

const Chip = ({children, clickHandler, active}) => {
    return <div className={`cool-chip ${active ? 'active' : ''}`} onClick={clickHandler}>{children}</div>
}

export default Chip;